// The settings slider — animation speed, the five sound levels.
//
// **MUI's `Slider`, re-skinned rather than rewritten.** Unlike `Toggle`, the
// hard part here is not geometry but behaviour — keyboard steps, marks, the
// pointer maths, `aria-valuenow` — and MUI's is right. What changes is the
// paint: a brand track and thumb over a gunmetal rail, no glow halo, so it sits
// in a `SettingRow` beside a `Toggle` without looking imported from elsewhere.
//
// Every colour is a token (`kit.test.ts`); the hover ring is brand sunk into
// transparency rather than MUI's alpha of the primary colour.

import { Slider as MuiSlider } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Slider = styled(MuiSlider)(({ theme }) => ({
  color: theme.kit.color.brand,
  height: 4,
  padding: "13px 0",
  "& .MuiSlider-rail": {
    color: theme.kit.color.line,
    opacity: 1
  },
  "& .MuiSlider-track": {
    border: 0
  },
  "& .MuiSlider-mark": {
    backgroundColor: theme.kit.color.lineHi,
    width: 2,
    height: 2
  },
  "& .MuiSlider-markActive": {
    backgroundColor: theme.kit.color.brandDown
  },
  "& .MuiSlider-thumb": {
    width: 14,
    height: 14,
    backgroundColor: theme.kit.color.brand,
    border: `2px solid ${theme.kit.color.brandDown}`,
    "&:hover, &.Mui-focusVisible": {
      boxShadow: `0 0 0 6px color-mix(in srgb, ${theme.kit.color.brand} 22%, transparent)`
    },
    "&.Mui-active": {
      boxShadow: `0 0 0 9px color-mix(in srgb, ${theme.kit.color.brand} 28%, transparent)`
    }
  },
  "&.Mui-disabled": {
    color: theme.kit.color.inkDim
  }
}));
